import React, { Suspense } from 'react'
import { Helmet } from 'react-helmet-async'

import { LoginFromTempLinkContainer } from '../Containers/LoginFromTempLinkContainer'
export const LoginFromTempLinkPage = () => {
	return (
		<div>
			<Helmet>
				<title>
					Авторизация по ссылке | Система конкурсного отбора претендентов по
					стипендии «Болашак»
				</title>
			</Helmet>
			<LoginFromTempLinkContainer />
		</div>
	)
}
